import { getDashboardMenu, CustomSideMenu1 } from './dashboard';
import qpDashboard from 'sidemenu/menu-items(qp-admin)/dashboard';
import { IconDashboard, IconHierarchy, IconUsers, IconReceipt } from '@tabler/icons';
// ==============================|| MENU ITEMS ||============================== //
const isSdCustomAdmin = localStorage.getItem('isSdCustomAdmin') === 'true';
const isQpAdmin = window.location.pathname.startsWith('/qp-admin');
const isUrban = localStorage.getItem('IsUrban') === 'true' || localStorage.getItem('IsUrban') === '1';

// Urban Dashboard — simplified menu for super-distributor
const urbanMenu = {
    id: 'urban-superdistributor-menu',
    type: 'group',
    children: [
        {
            id: 'urban-sd-dashboard',
            title: 'Dashboard',
            type: 'item',
            icon: IconDashboard,
            url: 'super-distributor/dashboard',
            breadcrumbs: true
        },
        {
            id: 'urban-sd-top-branches',
            title: 'Top Branches',
            type: 'item',
            icon: IconHierarchy,
            url: 'super-distributor/urban-top-branches',
            breadcrumbs: true
        },
        {
            id: 'urban-sd-merchants-list',
            title: 'Merchants List',
            type: 'item',
            icon: IconUsers,
            url: 'super-distributor/urban-merchants',
            breadcrumbs: true
        },
        {
            id: 'urban-sd-transactions-list',
            title: 'Transactions List',
            type: 'item',
            icon: IconReceipt,
            url: 'super-distributor/urban-transactions',
            breadcrumbs: true
        }
    ]
};

export const getSuperDistributorMenuItems = () => {
    let selectedMenu;

    if (isUrban) {
        selectedMenu = urbanMenu;
    } else if (isSdCustomAdmin) {
        selectedMenu = CustomSideMenu1;
    } else if (isQpAdmin) {
        selectedMenu = qpDashboard;
    } else {
        selectedMenu = getDashboardMenu();
    }

    return {
        items: [selectedMenu]
    };
};

const superDistributorMenuItems = getSuperDistributorMenuItems();

export default superDistributorMenuItems;
